import React from 'react';

import {
  Avatar,
  Box,
  Card,
  Typography,
  useTheme,
} from '@mui/material';
import { grey } from '@mui/material/colors';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const AiAnalysisNoData = () => {
  const theme = useTheme();

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Card
        variant="outlined"
        sx={{
          margin: 0,
          padding: 4,
          backgroundColor: theme.palette.background.grey,
          flexGrow: 1,
        }}
      >
        <Box display="flex" flexDirection="column" gap={2} alignItems="center" height="100%" justifyContent="center">
          <Avatar
            sx={{
              backgroundColor: grey[200],
              color: grey[400],
            }}
          >
            <AutoAwesomeIcon />
          </Avatar>
          <Box>
            <Typography fontWeight="bold" textAlign="center">No Analysis yet</Typography>
            <Typography textAlign="center">Select an analysis type above and get started</Typography>
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

export default AiAnalysisNoData;
